import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../services/authService'; // Import the logout service
import { useAuth } from '../../contexts/AuthContext'; // Import the AuthContext

function Navbar() {
  const navigate = useNavigate();
  const { logout: authContextLogout } = useAuth(); // Get the logout function from the context
  const [showSettings, setShowSettings] = useState(false);
  const settingsRef = useRef(null);

  const handleLogout = async () => {
    try {
      await logout();
      localStorage.removeItem('token');
      // Clear the user from the AuthContext
      authContextLogout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };
  
  const handleProfileClick = () => {
           navigate('/profile');
       };
   
  const handleSettingsClick = () => {
           setShowSettings(!showSettings);
       };
   
       // Close settings dropdown on outside click
  useEffect(() => {
           function handleClickOutside(event) {
               if (settingsRef.current && !settingsRef.current.contains(event.target)) {
                   setShowSettings(false);
               }
           }
           document.addEventListener('mousedown', handleClickOutside);
           return () => {
               document.removeEventListener('mousedown', handleClickOutside);
           };
    }, []);

  return (
           <nav className="navbar">
               <div className="navbar-left">
                   {/* You can add other elements here if needed */}
               </div>
               <div className="navbar-right">
                   <button className="settings-button" onClick={handleSettingsClick}>
                       ⚙️ {/* Or any settings icon */}
                   </button>
                   {showSettings && (
                       <div className="settings-dropdown" ref={settingsRef}>
                           <button onClick={handleProfileClick}>User Profile</button>
                           <button onClick={handleLogout}>Logout</button>
                       </div>
                   )}
               </div>
           </nav>
       );
}

export default Navbar;